import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { getActionExecutor } from '@organisms/actions/actionExecutorRegistry';
import { IActivityAction, IBaseAction } from '@models/actions/IBaseAction';
import { IActionExecutor } from '@organisms/actions/IActionExecutor';
import { ActivityLocationTypes } from './ActivityLocationTypes';
import { ActionAccessibleCheckResult } from '@models/actions/ActionAccessibleCheckResult';
import { IActionService, IGroupActionPlanSource } from '@services/actions/IActionService';
import { IGroupActionPlan } from '@models/actions/IGroupActionPlan';
import { getActivityIdFromCompositeId } from '@utils/helpers';

export class ActivityActionsService implements IActionService<IBaseAction> {
    private _location?: ActivityLocationTypes;

    constructor(location?: ActivityLocationTypes) {
        this._location = location;
    }

    /** Предпросмотр и выполнение по задачам («Мои задачи» и другие списки задач) */
    public readonly groupPlan: IGroupActionPlanSource = {
        planGroupAction: (ids: string[], actionKey: string, signal?: AbortSignal) =>
            $api.post<IGroupActionPlan>(
                `tasks/actions/${actionKey}/plan`,
                { ids, location: this._location ?? ActivityLocationTypes.PerformerFolder },
                { suppressErrorNotification: true, signal },
            ),
        toPlanId: getActivityIdFromCompositeId,
        groupRunParams: () => ({ location: this._location ?? ActivityLocationTypes.PerformerFolder }),
        objectNounForms: ['задача', 'задачи', 'задач'],
    };

    public getActionExecutor(act: IBaseAction): IActionExecutor {
        return getActionExecutor('activity', act)!;
    }

    //Получает все действия для активити
    async fetchActions(actId: string): Promise<AxiosResponse<IActivityAction[]>> {
        return $api.get<IActivityAction[]>(`tasks/getActionActivities/${actId}?location=${this._location}`);
    }

    //Получает все действия для группы активити
    async fetchGroupActions(actIds: string): Promise<AxiosResponse<IActivityAction[]>> {
        return $api.get<IActivityAction[]>(`tasks/getGroupActionActivities/${actIds}?location=${this._location}`);
    }

    async checkActionAccessibility(
        activityId: string | undefined,
        actionKey: string,
    ): Promise<AxiosResponse<ActionAccessibleCheckResult>> {
        return $api.get<ActionAccessibleCheckResult>(
            `activityActions/checkActionAccessibility/${actionKey}/${activityId ?? ''}`,
        );
    }

    async checkActionGroupAccessibility(
        activityIds: string | undefined,
        actionKey: string,
    ): Promise<AxiosResponse<ActionAccessibleCheckResult>> {
        const ids = activityIds?.split(',').filter((id) => id) ?? [];
        return $api.post<ActionAccessibleCheckResult>(
            `activityActions/checkActionGroupAccessibility/${actionKey}`,
            ids,
        );
    }
}
